var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UiFocusContainer',{ref:"focusContainer",staticClass:"ui-popover",class:{ 'is-raised': _vm.raised },attrs:{"role":"dialog","contain-focus":_vm.containFocus,"focus-redirector":_vm.focusRedirector},on:{"focus-overflow":function($event){return _vm.close()}}},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }